module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter2"
  }, [_c('strong', [_c('em', [_vm._v("Author’s Note")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("A "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NUMBER")]), _vm._v(" of accounts of May 8, 1902, have been written, mostly soon after the event when it was not possible for the authors to benefit from the many sources of evidence we have been able to call upon.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Inevitably, we have been confronted from time to time with conflicting evidence, as in the Guérin disaster, when some put the total dead as high as 400; as in the over-all death roll, which has been reputed to be 50,000; or in the number of survivors in the town, which has fluctuated between none and four.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Where we had to make a choice of fact, we relied most heavily on the official reports of the Académie des Sciences, the Royal Society, and the American Museum of Natural History.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Whenever there was a choice of interpretation, we relied on our own judgment. In these isolated instances, the decision was ours alone, and none of those who so generously helped us during our research should be thought to have automatically endorsed our portrayal of the events as we have described them.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("G. T. & M. M. W.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("London 1968")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0791a2d8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/authorsnote.vue
// module id = 72
// module chunks = 0